// Keyboard utility functions

/**
 * Convert language names to keyboard language codes
 * @param {string} lang - Language name or code
 * @returns {string} Keyboard language code
 */
export const getKeyboardLangCode = (lang) => {
  const langMap = {
    'Hebrew': 'he',
    'Yiddish': 'yi',
    'Spanish': 'es',
    'French': 'fr',
    'German': 'de',
    'Italian': 'it',
    'Portuguese': 'pt',
    'Mandarin': 'zh',
    'Chinese': 'zh',
    'zh-CN': 'zh',
    'zh': 'zh',
    'Arabic': 'ar',
    'Russian': 'ru',
    'Korean': 'ko',
    'Catalan': 'ca',
    'Vietnamese': 'vi',
    'Cantonese': 'yue',
    'yue': 'yue',
  };
  return langMap[lang] || 'en';
};

/**
 * Check if a language is RTL (Right-to-Left)
 * @param {string} lang - Language code
 * @returns {boolean} True if RTL language
 */
export const isRTL = (lang) => {
  const rtlLanguages = ['he', 'ar', 'fa', 'ur', 'yi', 'dv'];
  return rtlLanguages.includes(getKeyboardLangCode(lang));
};

/**
 * Get text direction for a language
 * @param {string} lang - Language code
 * @returns {string} 'rtl' or 'ltr'
 */
export const getTextDirection = (lang) => {
  return isRTL(lang) ? 'rtl' : 'ltr';
};

/**
 * Get text alignment for a language
 * @param {string} lang - Language code
 * @returns {string} 'right' or 'left'
 */
export const getTextAlign = (lang) => {
  return isRTL(lang) ? 'right' : 'left';
}; 